import { dispatchAction } from '@ardoq/rxbeach';
import { enterViewpointMode } from 'streams/traversals/actions';
import { PayloadActiveMainTabLeft, setActiveMainTabLeft } from './actions';

export const requestMainView = (payload: PayloadActiveMainTabLeft): void => {
  if (payload.isViewpointMode) {
    dispatchAction(enterViewpointMode());
  }
  dispatchAction(setActiveMainTabLeft(payload));
};
